const getApiBaseUrl = () => {
  const env = sessionStorage.getItem("adminEnvironment");
  if (env === "production") {
    return "https://homeowner-backend.azurewebsites.net/api";
  }
  // Default Staging
  return "https://homeowner-staging.azurewebsites.net/api";
};

const throwApiError = async (res: Response) => {
  let message = `API Error: ${res.status} ${res.statusText}`;
  try {
    const body = await res.json();
    message = body?.message || body?.error || message;
  } catch {
    // Keep the default HTTP status message when the response is not JSON.
  }
  throw new Error(message);
};

export const apiService = {
  get: async <T>(endpoint: string): Promise<T> => {
    const baseUrl = getApiBaseUrl();
    const res = await fetch(`${baseUrl}/${endpoint}`);
    if (!res.ok) {
      await throwApiError(res);
    }
    return res.json();
  },

  patch: async <T>(endpoint: string, body: any, headers?: Record<string, string>): Promise<T> => {
    const baseUrl = getApiBaseUrl();
    const res = await fetch(`${baseUrl}/${endpoint}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(headers || {}),
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      await throwApiError(res);
    }
    return res.json();
  },

  post: async <T>(endpoint: string, body: any): Promise<T> => {
    const baseUrl = getApiBaseUrl();
    const res = await fetch(`${baseUrl}/${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      await throwApiError(res);
    }
    return res.json();
  },

  put: async <T>(endpoint: string, body: any): Promise<T> => {
    const baseUrl = getApiBaseUrl();
    const res = await fetch(`${baseUrl}/${endpoint}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      await throwApiError(res);
    }
    return res.json();
  },

  delete: async <T>(endpoint: string): Promise<T> => {
    const baseUrl = getApiBaseUrl();
    const res = await fetch(`${baseUrl}/${endpoint}`, {
      method: "DELETE",
    });
    if (!res.ok) {
      await throwApiError(res);
    }
    return res.json();
  },
};
